import React from "react";
import { Box, Button, Chip, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ColumnDefinition, TableFilter } from "../../EmployeeDataDrawer";
import { getColumnLabel } from "../../helpers";

interface FilterChipsProps {
  filters: TableFilter[];
  columns: ColumnDefinition[];
  onRemoveFilter: (id: string) => void;
  onClearFilters: () => void;
}

export const FilterChips: React.FC<FilterChipsProps> = ({
  filters,
  columns,
  onRemoveFilter,
  onClearFilters,
}) => {
  const { t } = useTranslation();

  if (filters.length === 0) return null;

  return (
    <Box sx={{ px: 2, pb: 1 }}>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        {filters.map((filter) => (
          <Chip
            key={filter.id}
            label={`${getColumnLabel(columns, filter.columnKey)}: ${filter.value}`}
            onDelete={(): void => onRemoveFilter(filter.id)}
            color="primary"
            variant="outlined"
            size="small"
          />
        ))}
        <Button
          size="small"
          variant="text"
          onClick={onClearFilters}
          disabled={filters.length === 0}
        >
          {t("paygap.employeeData.filters.clear")}
        </Button>
      </Stack>
    </Box>
  );
};
